var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22 0H0v22h9.938v-8.007H8v-2.197h1.938v-1.208q0-2.196 1.175-3.392T14.403 6q.75 0 1.597.22l-.07 2.318a5.4 5.4 0 0 0-1.093-.097q-2.044 0-2.044 2.184v1.171h2.584v2.197h-2.584V22H22z",
  clipRule: "evenodd"
})));
export default SvgFacebookCircle;